import { Box, Form, Heading, mdBumps, Typo, xlBumps } from '@wrisk/ui-components'
import { isNil } from 'lodash-es'
import React, { FunctionComponent, useCallback, useState } from 'react'
import { useNavigate } from 'react-router'

import { isCancellationReasonInvalid } from '../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useUpButton } from '../../../../infrastructure/routing'
import { CancellationCoolingOffConfig } from '../../../../state/configuration'
import { CancellationReasonInput } from '../../../organisms/cancellation'
import { ActionBar } from '../../../organisms/form'
import { FullPage } from '../../../templates'
import { usePolicy } from '../PolicyProvider'
import { CancellationPath } from './CancellationPath'

export interface CancellationCoolingOffPageProps {
  config: CancellationCoolingOffConfig
}

const tKey = TKey('pages.cancel')

export const CancellationCoolingOffPage: FunctionComponent<
  CancellationCoolingOffPageProps
> = ({ config }) => {
  const navigate = useNavigate()

  const { t } = useWriskTranslation()

  const { policy } = usePolicy()

  const upButton = useUpButton({
    id: 'policy',
    url: '..',
  })

  const [cancellationReason, onReasonChange] = useState<string | null>(null)

  const onDismiss = useCallback(() => navigate('..'), [navigate])

  const onSubmit = useCallback(() => {
    navigate(CancellationPath.CONFIRM, {
      state: { cancellationReason },
    })
  }, [cancellationReason, navigate, policy])

  return (
    <FullPage
      pageId='policy-cancellation-page'
      header={t(tKey('header'))}
      subheader={t(tKey('subheader'))}
      upButton={upButton}
    >
      <Form data-testid='policy-cancellation-form' onSubmit={onSubmit}>
        {!isNil(config.reasons) && (
          <Box width={1}>
            <Heading variant='h3' as='h3' typoSize='md' mb={mdBumps}>
              {t(tKey('headers', 'reason'))}
            </Heading>
            <CancellationReasonInput
              width={1}
              onChange={onReasonChange}
              reasons={config.reasons}
              value={cancellationReason}
              mb={xlBumps}
            />
          </Box>
        )}

        <Box width={1} mb={xlBumps}>
          <Heading id='effective_label' variant='h3' typoSize='md' pb={mdBumps}>
            {t(tKey('headers', 'effective'))}
          </Heading>
          <Box padding={mdBumps} width={1} variant='raised'>
            <Typo>{t(tKey('immediately'))}</Typo>
          </Box>
        </Box>

        <ActionBar
          tKey={tKey}
          destructive
          disabled={isCancellationReasonInvalid(config.reasons, cancellationReason)}
          onDismiss={onDismiss}
        />
      </Form>
    </FullPage>
  )
}
